import { ButtonHeader } from 'common/components';
import React from 'react';

type Props = {
  header: string;
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
};

const ButtonHeaderExpand: React.FC<Props> = ({
  header,
  expanded,
  setExpanded
}) => (
  <ButtonHeader
    header={header}
    buttonHint={(expanded ? 'Retrair' : 'Expandir').concat(' todos')}
    icon={expanded ? 'angle-double-up' : 'angle-double-down'}
    onClick={() => {
      setExpanded(!expanded);
    }}
  ></ButtonHeader>
);

export { ButtonHeaderExpand };
